import { uploadUrl } from "../../lib/assets";
import { CONTACT_EMAIL } from "../../data/contact";
import { getRelatedProjects } from "../../data/projects";

/**
 * @param {{ project: import("../../data/projects").PROJECTS[0], onBack: () => void, onOpen: (id: string) => void }} props
 */
export default function ProjectArticle({ project, onBack, onOpen }) {
  const related = getRelatedProjects(project.id);
  const imageUrl = uploadUrl(project.img);

  return (
    <article className="project-article">
      <div
        className="project-article__hero"
        style={{ backgroundImage: `url('${imageUrl}')` }}
      >
        <div className="project-article__hero-scrim" />
        <div className="project-article__hero-content">
          <div className="project-article__category">
            {project.cat.toUpperCase()} · {project.year}
          </div>
          <h1 className="project-article__title">{project.title}</h1>
          <div className="project-article__byline">
            <span>CJ JAYAMAHA</span>
            <span aria-hidden="true">·</span>
            <span>{project.count}</span>
          </div>
        </div>
      </div>

      <div className="project-article__back-wrap">
        <button type="button" className="project-article__back" onClick={onBack}>
          ← ALL PROJECTS
        </button>
      </div>

      <div className="project-article__body">
        <p className="project-article__lead">{project.lead}</p>
        <p className="project-article__paragraph">
          A project is different from a single photograph. A photograph can be luck.
          A project has to be a decision, repeated — the same subject returned to again
          and again until it gives up something a single visit never could.
        </p>
        <p className="project-article__paragraph">
          What follows is a selection from the series, sequenced the way I would hang
          it on a wall rather than the order it was shot. The gaps between the frames
          are part of the work too.
        </p>

        <blockquote className="project-article__quote">
          &ldquo;{project.quote}&rdquo;
        </blockquote>
      </div>

      <div className="project-article__figures">
        <div
          className="project-article__figure project-article__figure--wide"
          style={{ backgroundImage: `url('${imageUrl}')` }}
        />
        <div
          className="project-article__figure project-article__figure--muted"
          style={{ backgroundImage: `url('${imageUrl}')` }}
        />
        <div
          className="project-article__figure project-article__figure--offset"
          style={{ backgroundImage: `url('${imageUrl}')` }}
        />
      </div>

      <div className="project-article__footer">
        <p className="project-article__paragraph">
          If you would like to see the full set, exhibit it, or commission something
          in the same spirit, I would love to hear from you. The work is always more
          interesting when it has somewhere to go.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="project-article__enquire">
          ENQUIRE ABOUT THIS PROJECT
        </a>
      </div>

      <section className="project-article__related">
        <div className="project-article__related-heading">MORE PROJECTS</div>
        <div className="project-article__related-grid">
          {related.map((item) => (
            <button
              key={item.id}
              type="button"
              className="project-article__related-card"
              onClick={() => onOpen(item.id)}
            >
              <div
                className="project-article__related-image"
                style={{ backgroundImage: `url('${uploadUrl(item.img)}')` }}
              />
              <div className="project-article__related-category">
                {item.cat.toUpperCase()}
              </div>
              <div className="project-article__related-title">{item.title}</div>
            </button>
          ))}
        </div>
      </section>
    </article>
  );
}
